import { render } from "./categoryAdd.vue?vue&type=template&id=6c88e424&scoped=true"
import script from "./categoryAdd.vue?vue&type=script&lang=js"
export * from "./categoryAdd.vue?vue&type=script&lang=js"

import "./categoryAdd.vue?vue&type=style&index=0&id=6c88e424&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./categoryAdd.vue?vue&type=style&index=1&id=6c88e424&lang=scss"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c88e424"]])

export default __exports__